import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'e51ad3b8-0b73-4ae9-a4d9-0a8b8fe3edf7',
  name: 'Draft',
  description:
    'The Engineering Judgement has been partially filled out and drafted, but is not yet ready to be issued',
  priority: 0,
})

const Closed = new StatusEnumItem({
  id: 'e1461c96-1afa-4510-8b37-4d8906df9b70',
  name: 'Closed',
  description:
    'The Engineering Judgement has been completely filled out and issued by an authorized user',
  priority: 1,
})

export type EJStatusItem = typeof Draft | typeof Closed

class EJStatusEnum extends StatusEnum<
  'EJStatus',
  EJStatusItem,
  EJStatusItem['name'],
  EJStatusItem['id'],
  EJStatusItem['priority']
> {
  readonly typename = 'EJStatus'
  readonly Draft = Draft
  readonly Closed = Closed
  get values() {
    return [this.Draft, this.Closed]
  }
}

export const EJStatus = new EJStatusEnum()
